import { Helmet } from "react-helmet-async";

const SITE = "My Eco Engineer";
const ORIGIN = "https://myecoengineer.com"; // canonical, non-www
const DEFAULT_DESC =
  "My Eco Engineer brings engineering principles to environmental health through research-backed Greenpapers, practical frameworks, Digital Blueprints, and carefully curated products.";
const DEFAULT_IMG = `${ORIGIN}/brand/mee-og.png`;

const GOOGLE_VERIFY = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
const BING_VERIFY = process.env.REACT_APP_BING_SITE_VERIFICATION;

// NOTE: This metadata is applied client-side via react-helmet-async. It improves
// structured data and social sharing for renderers that execute JavaScript, but it
// does NOT place substantive content or metadata in the initial HTML response.
// True crawlability of this content depends on the separate rendering-remediation phase.
export default function Seo({
  title,
  description,
  image,
  path = "",
  type = "website",
  robots = "index, follow",
  article, // { author, published, modified, section }
  jsonLd, // object or array of JSON-LD objects
}) {
  const fullTitle = title ? `${title}, ${SITE}` : `${SITE}, Reduce Toxic Exposure with Systems`;
  const desc = description || DEFAULT_DESC;
  const url = `${ORIGIN}${path}`;
  const img = image || DEFAULT_IMG;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />
      {GOOGLE_VERIFY && <meta name="google-site-verification" content={GOOGLE_VERIFY} />}
      {BING_VERIFY && <meta name="msvalidate.01" content={BING_VERIFY} />}

      <meta property="og:type" content={article ? "article" : type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      {article?.published && <meta property="article:published_time" content={article.published} />}
      {article?.modified && <meta property="article:modified_time" content={article.modified} />}
      {article?.author && <meta property="article:author" content={article.author} />}
      {article?.section && <meta property="article:section" content={article.section} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      <link rel="alternate" type="application/rss+xml" title="My Eco Engineer, Greenpapers" href={`${ORIGIN}/api/rss.xml`} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export const ORIGIN_URL = ORIGIN;
